import React, { useEffect, useState ,useRef} from "react";
import { Typography, Box, Card, Grid, Button } from "@mui/material";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import FamilyDetailsForm from "../Authentication/FamilyDetailsForm";
import axios from "axios";
import { matrimoneyEndPoints } from "../../../services/apis";

// Clean object keys by trimming whitespace
const cleanKeys = (obj = {}) =>
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.trim(), v]));

const FamilyView = (props) => {
  const [profileData,setProfileData] = useState(props?.profileData)
  const [open, setOpen] = useState(false);
  let getMyProfileData = localStorage.getItem("profileData")
  let MyProfileData = JSON.parse(getMyProfileData)
  let Api=useRef(false);
  let userType = sessionStorage.getItem("userType")
   const getCustomerData = async () => {
        try {
          let userType = sessionStorage.getItem("userType")
      let token
      if(userType){
        token = sessionStorage.getItem("token");
      }else{
         token = localStorage.getItem("token");
      }
          const response = await axios.post(
            matrimoneyEndPoints.VIEW_CUSTOMER_DETAILS,
            { profileId: props?.profileId},
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
    
          if (response.data.status) {
            setProfileData(response?.data?.data)
          }
        } catch (error) {
          console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
        } 
      };
       useEffect(() => {
            if (!Api.current) {
             Api.current = true
              getCustomerData();
            }
          }, []);
    // useEffect(()=>{
    //   getCustomerData()
    // },[open])
  // Handle no profile data
  if (!props?.profileData || typeof profileData !== "object") {
    return <p>No profile data available.</p>;
  }

  // Merge and clean all sections
//   const mergedFamilyData = {
//     ...cleanKeys(profileData["Family Details"]),
//     ...cleanKeys(profileData["Father Details"]),
//     ...cleanKeys(profileData["Mother Details"]),
//     ...cleanKeys(profileData["Reference Details"]),
//   };

  // Initialize sections as objects (not strings!)
  const groupData = {
    family: profileData["Family Details"] || {},
    father: profileData["Father Details"] || {},
    mother: profileData["Mother Details"] || {},
    reference: profileData["Reference Details"] || {},
  };

  // Categorize fields into the appropriate section
//   Object.entries(mergedFamilyData).forEach(([key, value]) => {
//     const lowerKey = key.toLowerCase();
//     if (lowerKey.includes("father")) {
//       groupData.father[key] = value;
//     } else if (lowerKey.includes("mother")) {
//       groupData.mother[key] = value;
//     } else if (lowerKey.includes("reference")) {
//       groupData.reference[key] = value;
//     } else {
//       groupData.family[key] = value;
//     }
//   });

  // Render card section with fields
  const renderSection = (sectionTitle, sectionData) => (
    <Card
      sx={{
        padding: "10px 50px",
        mb: "20px",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        border: "3px solid rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography sx={{ ...styles.viewtextstyle }}>{sectionTitle}</Typography>
      <Grid container spacing={2}>
        {Object.entries(sectionData).map(([label, value], index) => (
          <Grid item xs={12} sm={6} key={index} sx={{ padding: "10px", borderBottom: "2px dotted #ccc",  }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                sx={{
                  fontFamily: '"Roboto Condensed", sans-serif',
                  fontWeight: 700,
                  fontSize: "20px",
                }}
              >
                {label}
              </Typography>
              <Typography sx={{ fontSize: "20px" }}>{value || "--"}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Card>
  );

  return (
    <Box>
      <Box sx={{ display: "flex",justifyContent: "flex-end", mb: 2 }}>
        {/* <Typography
          sx={{
            fontFamily: '"Roboto Condensed", sans-serif',
            fontWeight: 600,
            fontSize: "24px",
          }}
        >
          Family Details
        </Typography> */}
        {((MyProfileData && MyProfileData.id == props?.profileId) || userType) && <Button
          variant="contained"
          onClick={() => setOpen(!open)}
          sx={{
            backgroundColor: "#C1721F",
            color: "white",
            display: "flex",
            gap: "5px",
            marginRight: { xs: "60px", sm: "0px" },
          }}
        >
          {open ? "View" : "Edit"}
        </Button>}
      </Box>

      {!open ? (
         <Card
                   sx={{
                     ...styles.cardeducation,
                     height: { xs: "auto", sm: "auto" },
                     padding: { xs: 2, sm: 4 },
                     borderRadius: "5px",
                   }}
                 >
          <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
          <Box
            sx={{
              width: "100%",
              margin: "auto",
              backgroundColor: "white",
              border: "2px solid #C1721F",
              padding: { xs: "10px", sm: "30px" },
              borderRadius: "10px",
            }}
          >
            {renderSection("Family Details", groupData.family)}
            {Object.keys(groupData.father).length > 0 && renderSection("Father Details", groupData.father)}
            {Object.keys(groupData.mother).length > 0 && renderSection("Mother Details", groupData.mother)}
            {Object.keys(groupData.reference).length > 0 && renderSection("Reference Details", groupData.reference)}
          </Box>
        </Card>
      ) : (
        <Box sx={{ width: { xs: "auto", sm: "800px", md: "1405px" }, margin: "auto" }}>
          <FamilyDetailsForm type="edit" onSubmitSuccess={() => setOpen(false)}  />
        </Box>
      )}
    </Box>
  );
};

export default FamilyView;
